//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function transaction_status(query) {
    // console.log("transaction_status (get_transaction) -> request", query);
    return await new API().apiGet({
        baseUrl: process.env.PAYMENT_ENGINE_URL ?? "",
        endpoint: `pay/get_transaction${objectToQueryString(query)}`, //
        authorization: process.env.PAYMENT_ENGINE_CLIENT_TOKEN,
    });
}
export { transaction_status };
